import { isEmpty } from 'remeda'
import { createAppFromCommonTemplate, lazyImport } from '@helpers'
import type { CollectionMessageData } from '@velasca/types'

const { CollectionTextSection } = lazyImport(
  () => import('@velasca/ui/collection-text-section'),
  'CollectionTextSection',
)

export const renderCollectionTopMessageApp = (
  collectionTopMessageEl: HTMLElement | null,
  collectionTopMessageData: CollectionMessageData,
) => {
  if (!collectionTopMessageData || isEmpty(collectionTopMessageData)) {
    return
  }

  const { title, upperTitle, paragraph } = collectionTopMessageData

  createAppFromCommonTemplate(
    collectionTopMessageEl,
    <CollectionTextSection
      title={title}
      upperTitle={upperTitle}
      paragraph={paragraph}
    />,
  )
}
